module.exports = __webpack_public_path__ + "static/media/coffee-explore-more.360a974a.jpg";